import { render } from "./factor-price.vue?vue&type=template&id=64a1ca0b&scoped=true&lang=pug"
import script from "./factor-price.vue?vue&type=script&lang=js"
export * from "./factor-price.vue?vue&type=script&lang=js"

import "./factor-price.vue?vue&type=style&index=0&id=64a1ca0b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a1ca0b"]])

export default __exports__